/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseSettingsGroupingDescriptionsInner
 */
export interface DatabaseSettingsGroupingDescriptionsInner {
    /**
     * stable client-generated id for sortable/keyed UI
     * @type {string}
     * @memberof DatabaseSettingsGroupingDescriptionsInner
     */
    id?: string;
    /**
     * the value of the groupBy field this description applies to
     * @type {string}
     * @memberof DatabaseSettingsGroupingDescriptionsInner
     */
    value?: string;
    /**
     * HTML description text (TipTap output)
     * @type {string}
     * @memberof DatabaseSettingsGroupingDescriptionsInner
     */
    description?: string;
}

/**
 * Check if a given object implements the DatabaseSettingsGroupingDescriptionsInner interface.
 */
export function instanceOfDatabaseSettingsGroupingDescriptionsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSettingsGroupingDescriptionsInnerFromJSON(json: any): DatabaseSettingsGroupingDescriptionsInner {
    return DatabaseSettingsGroupingDescriptionsInnerFromJSONTyped(json, false);
}

export function DatabaseSettingsGroupingDescriptionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSettingsGroupingDescriptionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function DatabaseSettingsGroupingDescriptionsInnerToJSON(value?: DatabaseSettingsGroupingDescriptionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
        'description': value.description,
    };
}

